<div class="header">
  <div class="headerNavbar">
    {{'header.hello' | translate}} <strong>{{ userInfo.email }}</strong>
    <a (click)="logout()">{{ "general.logout" | translate }} <span class="icon ti-shift-left"></span></a>
  </div>
</div>